module.exports = __webpack_public_path__ + "static/img/wl_1.abd65d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/wl_1.png
// module id = 312
// module chunks = 1